import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ClinicOfficeManageService } from 'src/shop-manager/services/clinic-office-manage.service';
import { ClinicOfficeListItem } from 'src/shop-manager/common/models/internal/clinic-office-list-item.model';
import { CountriesEnum } from 'src/common-panel/enums/countries-enum';
import { ServerValueInterpreterService } from 'src/common-panel/services/server-value-interpreter.service';
import { ClinicTypesEnum } from 'src/shop-manager/common/enums/clinic-types-enum';
import { ShopTypesEnum } from 'src/common-panel/enums/shop-types-enum';
import { CrmTypesEnum } from 'src/common-panel/enums/crm-types-enum';
import { BrandTypesEnum } from 'src/common-panel/enums/brand-types-enum';
import { CountryId } from 'src/common-panel/constants/country-configs.constants';

@Component({
    selector: 'app-review-edit-clinic-office-dialog',
    templateUrl: './review-edit-clinic-office-dialog.component.html',
    styleUrls: ['./review-edit-clinic-office-dialog.component.css'],
    standalone: false
})
export class ReviewEditClinicOfficeDialogComponent
{
  currentClinicOffice: ClinicOfficeListItem | undefined
  editedClinicOffice: ClinicOfficeListItem | undefined
  // comment: string
  // editedComment: string

  isUs: boolean = false
  isPhysical: boolean = false
  isOffice: boolean = false

  constructor(private _dialog: MatDialog, private serverValueInterpreterService: ServerValueInterpreterService,
    private clinicOfficeManageService: ClinicOfficeManageService)
  {
    this.currentClinicOffice = this.clinicOfficeManageService.currentClinicOffice
    this.editedClinicOffice = this.clinicOfficeManageService.editedClinicOffice

    if (this.clinicOfficeManageService.editedClinicOffice?.countryId.toString() == "US") this.isUs = true
    if (this.clinicOfficeManageService.currentClinicOffice?.shopType == ClinicTypesEnum.physical)
    {
      this.isPhysical = true
    } else
    {
      this.isPhysical = false
    }

    if (this.clinicOfficeManageService.currentClinicOffice?.type1 == ShopTypesEnum.entOffice)
    {
      this.isOffice = true
    } else
    {
      this.isOffice = false
    }
  }

  getStateName(state: string): string
  {
    return this.serverValueInterpreterService.getStateName(state);
  }

  onSubmit()
  {
    this.clinicOfficeManageService.editClinicOffice()
    this._dialog.closeAll();
  }

  getCRMNameByNumber(crmNumber: number): CrmTypesEnum | undefined
  {
    return this.serverValueInterpreterService.getCRMNameByNumber(crmNumber)
  }

  compareLocation(current: { longitude: string; latitude: string; } | undefined, edited: { longitude: string; latitude: string; } | undefined): boolean
  {
    if (current && edited) return current.longitude != edited.longitude || current.latitude != edited.latitude
    else return true
  }

  isSameArray(oldValues: string[], newValues: string[]): boolean
  {
    if (oldValues.length != newValues.length) return false
    let l_res = true
    oldValues.forEach((l_oldValue, index) =>
    {
      if (l_oldValue != newValues[index]) l_res = false
    })
    return l_res
  }

  getFullCountryName(countryId?: CountryId): CountriesEnum | string
  {
    if (countryId) return this.serverValueInterpreterService.getFullCountryNameById(countryId)
    return ''
  }

  getFullType1(type1?: ShopTypesEnum): string
  {
    if (type1) return this.serverValueInterpreterService.getFullType1(type1)
    return ''
  }

  getBrandName(brandId: BrandTypesEnum): string
  {
    return this.serverValueInterpreterService.getBrandName(brandId)
  }
}
